export const cachedTables = [];

export const sortAndFieldsCachedTables = [
    'contacts'
];

export const fullCachedTables = [];
